module.exports = __webpack_public_path__ + "static/img/enenery.265de34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/enenery.jpg
// module id = ya/U
// module chunks = 2